export default { // france polonesia example
    tag: 'fr-FR',
    label: 'FR',
    labelFull: 'français (France)',
    flag: 'france',
    messages: {
        message: {}
    },
    datetimeFormats : {
        short: {
            year: 'numeric', month: '2-digit', day: 'numeric',
        },
        long: {
            year: 'numeric', month: 'long', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        },
        full : {
            year: 'numeric', month: 'long', day: 'numeric',
            weekday: 'long', hour: 'numeric', minute: 'numeric', timeZoneName: 'short'
        }
    },
    numberFormats: {
        currency: {
            style: 'currency', currency: 'XPF', useGrouping: true, currencyDisplay: 'symbol', maximumFractionDigits: 0
        },
        decimal: {
            style: 'decimal', minimumSignificantDigits: 3, maximumSignificantDigits: 5
        },
        percent: {
            style: 'percent', useGrouping: false
        },
    },
    useTitleCase: false,
    translateNumber (instance, value, type, local, options) {
        if (type == 'currency') { // value is not in some form of "cent" - it is in F and they symbol is F
            value = value * 100;
            return instance.$n(value, type, local, options).replace('FCFP', 'F')
        }


        // regular number formatting
        return instance.$n(value, type, local, options)
    }
}
